import React from 'react';
import MathEscapeRoom from 'views/MathEscapeRoom';

const MathClubPage = () => {
  return <MathEscapeRoom/>;
};

export default MathClubPage;

